export const CLOSE_CAMPAIGN_SERVICE_EDITOR = 'CLOSE_CAMPAIGN_SERVICE_EDITOR';
export type CLOSE_CAMPAIGN_SERVICE_EDITOR = typeof CLOSE_CAMPAIGN_SERVICE_EDITOR;

export interface CloseCampaignServiceEditor {
    type: CLOSE_CAMPAIGN_SERVICE_EDITOR;
    editorId: string;
}

export function closeCampaignServiceEditorAction(editorId: string): CloseCampaignServiceEditor {
    return {
        type: CLOSE_CAMPAIGN_SERVICE_EDITOR,
        editorId
    };
}
